/**
 * @desc 保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: defs.basics.OrderCompanySaveDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/orderCompany/saveOrUpdate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
